module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flowers_d9bbee.jpg";